import React from 'react';
import classNames from 'classnames';

import Icon from 'buyside/components/presentation/Icon/icon';

import styles from 'buyside/components/presentation/Skeleton/skeletonStyles.scss';

export enum SKELETON_SIZES {
  SMALL = 'smallSize',
  MEDIUM = 'mediumSize',
  LARGE = 'largeSize',
  FULL = 'fullSize'
}

export enum SKELETON_WIDTHS {
  TINY = 'tinyWidth',
  SMALL = 'smallWidth',
  MEDIUM = 'mediumWidth',
  LARGE = 'largeWidth',
  ONE_THIRD = 'oneThirdWidth',
  TWO_THIRD = 'twoThirdWidth',
  FULL = 'fullWidth'
}

export enum SKELETON_SHAPES {
  CIRCLE = 'circle'
}

interface SkeletonProps {
  size?: SKELETON_SIZES;
  width?: SKELETON_WIDTHS;
  shape?: SKELETON_SHAPES;
  customClass?: string;
  containerHeight?: number;
  containerWidth?: number;
  svg?: SVGElement;
}

const Skeleton: React.FC<SkeletonProps> = ({
  size = SKELETON_SIZES.MEDIUM,
  width = SKELETON_WIDTHS.FULL,
  shape = 0,
  customClass,
  containerHeight,
  containerWidth,
  svg
}) => {
  if (svg) {
    return <Icon type={svg} className={classNames(styles.skeletonSvg, customClass)} />;
  }
  if (containerHeight || containerWidth)
    return (
      <div
        style={{ height: containerHeight, width: containerWidth }}
        className={classNames(styles.skeletonContainer, customClass, styles[shape])}
      >
        <Skeleton size={SKELETON_SIZES.FULL} />
      </div>
    );

  return <span className={classNames(styles.skeleton, customClass, styles[size], styles[width])} />;
};

export default Skeleton;
